import "./Backdrop.scss";

// Veoma koristan kurs 
// https://www.youtube.com/watch?v=l6nmysZKHFU
const Backdrop = () => (
    <div className="Backdrop"/>
);
export default Backdrop;
